import { regExp } from '@sigma-frontend-libs/commons'
import { Currency } from '@sigmasms/shared-types'

import { components, services } from '@/utils'

// NOTE: Так как счета мы пока не умеем выставлять
// ни в какой другой валюте кроме RUB
// то и валюта суммы счета всегда RUB
export default function(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${services.invoices}.labels.amount`),
        suffix: this.getTranslate(`currency.${Currency.RUB}.symbol.unicode`),
        disabled: this.disabled,
        required: true,
        autofocus: true,
        clearable: true,
        details: false,
        mask: regExp.positiveNumberTwoSymbolsAfterDot,
        processValue: value => {
          return value?.toString().replace(',', '.')
        }
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
